(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import { Grid as MuiGrid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex'
    }
  };
});

var Grid = function Grid(props) {
  var children = props.children;
  var classes = useStyles(); // const {xs, sm, md, lg, xl} = props;

  return React.createElement(MuiGrid, _extends({}, props, {
    className: classes.root
  }), children);
};

__signature__(Grid, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Grid;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/home/vsts/work/1/s/src/components/layout/Grid.js");
  reactHotLoader.register(Grid, "Grid", "/home/vsts/work/1/s/src/components/layout/Grid.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/layout/Grid.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();